import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall, sinReducerSuccess} from './ajaxStatusActions';
import moment from 'moment';

 




export function getCursosActualesSuccess(cursos) {
  return {type: types.LOAD_CURSOS_ACTUALES_SUCCESS, datos:cursos};
}



export function getCursosActuales( token ) {
     
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoApi.getCursosActuales(token ).then(cursos => {                  
                  dispatch(getCursosActualesSuccess(cursos));
                  return cursos;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function getCursosSolicitados(token ) {
     
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoApi.getCursosSolicitados(token ).then(cursosSolicitados => {                  
                  dispatch(sinReducerSuccess());
                  return cursosSolicitados;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}

export function getCursoTipoComboSuccess(datos) {
  return {type: types.GET_CURSOS_TIPO_COMBO_SUCCESS, datos};
}

export function getCursoTipoCombo(token) {
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().CursoApi.getCursoTipoCombo(token).then(datos => {   
      dispatch(getCursoTipoComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}



export function saveImagen(datos, token) {
  return dispatch => {
	dispatch(beginAjaxCall());  
        return Api().CursoApi.saveImagen(datos, token).then((foto) => {            
        dispatch(sinReducerSuccess(foto.descripcion));   
         return foto;    
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function validarCupon(datos, id, token) {
  return dispatch => {
	dispatch(beginAjaxCall());  
        return Api().CursoApi.validarCupon(datos, id, token).then((cupon) => {            
        console.log(cupon);
        dispatch(sinReducerSuccess(cupon));   
        console.log(cupon);
        return cupon;    
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}



 
export function inscribir(id, tipo,codigo,  token ) {
     
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoApi.inscribir(id,tipo, codigo,  token ).then(() => {                  
                  dispatch(sinReducerSuccess());
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getCursoListSuccess(curso) {
  return {type: types.LOAD_CURSO_LIST_SUCCESS, curso};
}



export function getCursoList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoApi.getCursoList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(curso => {                  
                  dispatch(getCursoListSuccess(curso));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function getCursosProfesorListSuccess(curso) {
  return {type: types.LOAD_CURSOS_PROFESOR_LIST_SUCCESS, curso};
}



export function getCursosProfesor(token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoApi.getCursosProfesor(token).then(curso => {                  
                  dispatch(getCursosProfesorListSuccess(curso));
                  return curso;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getCursoSuccess(catalogo) {
  return {type: types.LOAD_CURSO_SUCCESS, catalogo};
}

export function getCurso(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().CursoApi.getCurso(id, token).then(curso => {  
            for(let i=0; i<curso.idsModulos.length;i++){
               curso.idsModulos[i].fechaInicio=new moment(curso.idsModulos[i].fechaInicio,"MM-DD-YYYY"); 
            curso.idsModulos[i].fechaFin= new moment(curso.idsModulos[i].fechaFin,"MM-DD-YYYY"); 
            }
        dispatch(getCursoSuccess(curso));
        return curso;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(curso) {
  return {type: types.SAVE_CURSO_SUCCESS, curso};
}


export function save(curso, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().CursoApi.save(curso, token).then(cursoGuardado => {   
    dispatch(saveSuccess(cursoGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function saveNuevo(curso, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().CursoApi.saveNuevo(curso, token).then(cursoGuardado => {   
    dispatch(saveSuccess(cursoGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function setDuplicar(curso, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().CursoApi.setDuplicar(curso, token).then(cursoGuardado => {   
    dispatch(saveSuccess(cursoGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}





export function getCursoComboSuccess(datos) {
  return {type: types.GET_CURSOS_COMBO_SUCCESS, datos};
}

export function getCursoCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().CursoApi.getCursoCombo(token).then(datos => {   
        
      dispatch(getCursoComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(curso) {
  return {type: types.BORRAR_CURSO_SUCCESS, curso};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoApi.borrar(id, token ).then(curso => {
               
                  dispatch(borrarSuccess(curso));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(curso) {
  return {type: types.ACTIVAR_CURSO_SUCCESS, curso};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoApi.activar(id, token).then(curso => {
               
                  dispatch(activarSuccess(curso));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_CURSO, filtro};
}

export function setVisto(contenidoVisto, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoApi.setVisto(contenidoVisto, token).then(curso => {
               
                  dispatch(sinReducerSuccess(curso));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}

